<h2 class="sub-header-bar" *ngIf="title">{{ title }}</h2>

<form *ngIf="showFilterPane" (ngSubmit)="search()" style="width: 100%">
  <div class="ui-g filterPanel card">
    <div class="ui-g-12 ui-md-3 ui-lg-3">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.from.value"
          name="invoiceDateFrom"
          dateFormat="dd/mm/yy"
        ></p-calendar>
        <label>From</label>
      </span>
    </div>

    <div class="ui-g-12 ui-md-3 ui-lg-3">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.to.value"
          name="invoiceDateTo"
          dateFormat="dd/mm/yy"
        ></p-calendar>
        <label>To</label>
      </span>
    </div>

    <div class="ui-g-12 ui-md-3 ui-lg-3">
      <span class="md-inputfield filterItem">
        <p-dropdown
          name="supplier"
          [options]="invoiceSuppliers"
          [(ngModel)]="filterVal.filters.supplierId.value"
          filter="true"
        ></p-dropdown>
      </span>
    </div>

    <div class="ui-g-12 ui-md-3 ui-lg-3">
      <button pButton type="submit" label="Search" class="ui-button btn-to-right"></button>
      <button
        *ngIf="showReportButton"
        pButton
        type="button"
        label="Report"
        class="ui-button btn-to-right"
        (click)="requestInvoiceReport(processingStatus_unbatchedInvoice)"
      ></button>
      <button
        pButton
        type="button"
        label="Clear"
        class="ui-button ui-button-tertiary btn-to-right"
        (click)="clearFilter(dt)"
      ></button>
    </div>
  </div>
</form>

<p-table
  #dt
  [value]="page.items"
  [lazy]="true"
  [rows]="10"
  [responsive]="true"
  [paginator]="true"
  rowHover="true"
  resizableColumns="true"
  [totalRecords]="page.total"
  (onLazyLoad)="onGridLazyLoad($event)"
  [first]="filterVal.first"
  [hidden]="!isLoaded"
  [rowsPerPageOptions]="[5, 10, 20]"
  [pageLinks]="3"
  [(selection)]="selectedInvoice"
  selectionMode="single"
  (onRowSelect)="onInvoiceSelect($event.data)"
  [sortField]="filterVal.sortField"
  [sortOrder]="filterVal.sortOrder"
  tableStyleClass="no-print"
>
  <ng-template pTemplate="header">
    <tr>
      <th *ngIf="isVmeMode" pSortableColumn="supplierName">
        Supplier
        <p-sortIcon field="supplierName"></p-sortIcon>
      </th>
      <th *ngIf="isVmeMode">Is Self Billed</th>
      <th pSortableColumn="invoiceNumber">
        Invoice
        <p-sortIcon field="invoiceNumber"></p-sortIcon>
      </th>
      <th pSortableColumn="invoiceDate">
        Date
        <p-sortIcon field="invoiceDate"></p-sortIcon>
      </th>
      <th
        pSortableColumn="billedDate"
        *ngIf="isTestMode && processingStatus == processingStatus_batch"
      >
        Billed On
        <p-sortIcon field="billedDate"></p-sortIcon>
      </th>
      <th
        pSortableColumn="subTotalVAT"
        *ngIf="
          isSupplierMode ||
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_failedPayment
        "
      >
        Amount VAT
        <p-sortIcon field="subTotalVAT"></p-sortIcon>
      </th>
      <th
        pSortableColumn="subTotalNoVAT"
        *ngIf="
          isSupplierMode ||
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_failedPayment
        "
      >
        Amount No-VAT
        <p-sortIcon field="subTotalNoVAT"></p-sortIcon>
      </th>
      <th
        pSortableColumn="vatAmount"
        *ngIf="
          isSupplierMode ||
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_failedPayment
        "
      >
        VAT
        <p-sortIcon field="vatAmount"></p-sortIcon>
      </th>
      <th pSortableColumn="total">
        Total
        <p-sortIcon field="total"></p-sortIcon>
      </th>
      <th *ngIf="isSupplierMode && !supplierAgreedSelfBilling">Supp Inv</th>
      <th *ngIf="isSupplierMode && !supplierAgreedSelfBilling">Supp Inv Date</th>
      <th
        pSortableColumn="paidOn"
        *ngIf="
          isSupplierMode ||
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_supplier
        "
      >
        Paid
        <p-sortIcon field="paidOn"></p-sortIcon>
      </th>
      <th
        *ngIf="
          isSupplierMode ||
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_supplier
        "
      >
        Xero Batch Invoice Num
      </th>
      <th *ngIf="processingStatus == processingStatus_cancelled">Cancelled</th>
      <th *ngIf="processingStatus == processingStatus_cancelled">Reason</th>
      <th *ngIf="processingStatus == processingStatus_failedPayment">Status + Reason</th>
      <th *ngIf="isSupplierMode">View</th>
      <th
        *ngIf="
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_failedPayment ||
          processingStatus == processingStatus_unbatchedInvoice ||
          processingStatus == processingStatus_supplier
        "
      >
        ProForma/Invoice
        <p-sortIcon field="paymentDate"></p-sortIcon>
      </th>
      <th
        *ngIf="
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_failedPayment ||
          processingStatus == processingStatus_unbatchedInvoice
        "
      >
        SupplierInv
      </th>
      <th
        *ngIf="
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_failedPayment ||
          processingStatus == processingStatus_unbatchedInvoice
        "
      >
        SupplierInv Date
      </th>
      <th
        *ngIf="
          isTestMode &&
          (processingStatus == processingStatus_batch ||
            processingStatus == processingStatus_unbatchedInvoice)
        "
      >
        Testing
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
    <tr [pSelectableRow]="item">
      <td *ngIf="isVmeMode">{{ item.supplierName }}</td>
      <td style="text-align: center">{{ item.isSelfBilled ? 'Yes' : 'No' }}</td>
      <td>{{ item.invoiceNumber }}</td>
      <td>{{ item.invoiceDate | datex : 'DD MMM YYYY' }}</td>
      <td *ngIf="isTestMode && processingStatus == processingStatus_batch">
        {{ item.billedDate | datex : 'DD MMM YYYY' }}
      </td>
      <td
        *ngIf="
          isSupplierMode ||
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_failedPayment
        "
      >
        {{ item.subTotalVAT | currency : 'GBP' : 'symbol' : '1.2-2' }}
      </td>
      <td
        *ngIf="
          isSupplierMode ||
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_failedPayment
        "
      >
        {{ item.subTotalNoVAT | currency : 'GBP' : 'symbol' : '1.2-2' }}
      </td>
      <td
        *ngIf="
          isSupplierMode ||
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_failedPayment
        "
      >
        {{ item.VAT | currency : 'GBP' : 'symbol' : '1.2-2' }}
      </td>
      <td>
        {{ item.total | currency : 'GBP' : 'symbol' : '1.2-2' }}
      </td>
      <td *ngIf="isSupplierMode && !supplierAgreedSelfBilling">
        <a href="~" (click)="openPdf(item.supplierInvoicePdf); $event.preventDefault()">{{
          item.supplierInvoiceNumber
        }}</a>
        <span *ngIf="!item.supplierInvoiceNumber">Outstanding</span>
      </td>
      <td *ngIf="isSupplierMode && !supplierAgreedSelfBilling">
        {{ item.supplierInvoiceDate | datex : 'DD MMM YYYY' }}
      </td>
      <td
        *ngIf="
          isSupplierMode ||
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_supplier
        "
      >
        <span *ngIf="item.paidOn">{{ item.paidOn | datex : 'DD MMM YYYY' }}</span>
        <span *ngIf="!item.paidOn" style="text-transform: capitalize">{{
          item.paymentStatus
        }}</span>
      </td>
      <td
        *ngIf="
          isSupplierMode ||
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_supplier
        "
      >
        <span *ngIf="item.xeroInvoiceNumber">{{ item.xeroInvoiceNumber }}</span>
      </td>
      <td *ngIf="processingStatus == processingStatus_cancelled">
        {{ item.invoiceCancelledOn | datex : 'DD MMM YYYY' }}
      </td>
      <td *ngIf="processingStatus == processingStatus_cancelled">
        {{ item.invoiceCancelledReason }}
      </td>
      <td *ngIf="processingStatus == processingStatus_failedPayment"></td>
      <td *ngIf="isSupplierMode" style="text-align: center">
        <a
          href="~"
          *ngIf="!supplierAgreedSelfBilling && item.supplierInvoiceNumber"
          (click)="openPdf(item.supplierInvoicePdf); $event.preventDefault()"
        >
          <span class="ui-clickable fa fa-fw ui-icon-document"></span>
        </a>
        <a
          *ngIf="supplierAgreedSelfBilling"
          (click)="openInvoiceViewPanel(item.id); $event.preventDefault()"
        >
          <span class="ui-clickable fa fa-fw ui-icon-document"></span>
        </a>
      </td>
      <td
        *ngIf="
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_failedPayment ||
          processingStatus == processingStatus_unbatchedInvoice ||
          processingStatus == processingStatus_supplier
        "
        style="text-align: center"
      >
        <a
          *ngIf="item.supplierInvoiceNumber"
          href="~"
          (click)="openPdf(item.supplierInvoicePdf); $event.preventDefault()"
        >
          <span class="ui-clickable fa fa-fw ui-icon-document"></span>
        </a>
        <a
          *ngIf="!item.supplierInvoiceNumber"
          (click)="openInvoiceViewPanel(item.id); $event.preventDefault()"
        >
          <span class="ui-clickable fa fa-fw ui-icon-document"></span>
        </a>
      </td>
      <td
        style="text-align: center"
        *ngIf="
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_failedPayment ||
          processingStatus == processingStatus_unbatchedInvoice
        "
      >
        <a href="~" (click)="openPdf(item.supplierInvoicePdf); $event.preventDefault()">{{
          item.supplierInvoiceNumber
        }}</a>
      </td>
      <td
        *ngIf="
          processingStatus == processingStatus_batch ||
          processingStatus == processingStatus_failedPayment ||
          processingStatus == processingStatus_unbatchedInvoice
        "
      >
        {{ item.supplierInvoiceDate | datex : 'DD MMM YYYY' }}
      </td>
      <td
        *ngIf="
          isTestMode &&
          (processingStatus == processingStatus_batch ||
            processingStatus == processingStatus_unbatchedInvoice)
        "
      >
        <a href="#" (click)="removeInvoice(item.id); $event.preventDefault()">Remove</a>
        <br /><br />
        <div *ngIf="item.transactionId">
          Webhook:
          <a href="#" (click)="emulateWebhookCompleted(item); $event.preventDefault()">completed</a>
          |
          <a href="#" (click)="emulateWebhookFailed(item); $event.preventDefault()">failed</a>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<!-- DATATABLE DEPRECATED --

<p-dataTabl #dt [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true"
             [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" [first]="filterVal.first"
             [hidden]="!isLoaded" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3" [(selection)]="selectedInvoice"
             selectionMode="single" (onRowSelect)="onInvoiceSelect($event.data)"
             [sortField]="filterVal.sortField" [sortOrder]="filterVal.sortOrder" tableStyleClass="no-print">
    <p-column *ngIf="isVmeMode" field="supplierName" header="Supplier" [sortable]="true" [style]="{'width' : '15%'}"></p-column>
    <p-column *ngIf="isVmeMode" field="isSelfBilled" header="Is Self Billed" [sortable]="false" styleClass="align-center">
        <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] ? 'Yes' : 'No' }}
        </ng-template>
    </p-column>
    <p-column field="invoiceNumber" header="Invoice" [sortable]="true" styleClass="align-center"></p-column>
    <p-column field="invoiceDate" header="Date" [sortable]="true" styleClass="align-center">
        <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | datex:'DD MMM YYYY' }}
        </ng-template>
    </p-column>
    <p-column *ngIf="isTestMode && processingStatus == processingStatus_batch"
              field="billedDate" header="Billed On" [sortable]="true" styleClass="align-center">
        <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | datex:'DD MMM YYYY' }}
        </ng-template>
    </p-column>
    <p-column *ngIf="isSupplierMode || processingStatus == processingStatus_batch || processingStatus == processingStatus_failedPayment"
              field="subtotalVAT" header="Amount (VAT)" [sortable]="true" styleClass="align-center">
        <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | currency:'GBP':'symbol':'1.2-2' }}
        </ng-template>
    </p-column>
    <p-column *ngIf="isSupplierMode || processingStatus == processingStatus_batch || processingStatus == processingStatus_failedPayment"
    field="subtotalNoVAT" header="Amount (No-VAT)" [sortable]="true" styleClass="align-center">
        <ng-template let-col let-item="rowData" pTemplate="body">
        {{ item[col.field] | currency:'GBP':'symbol':'1.2-2' }}
        </ng-template>
    </p-column>

    <p-column *ngIf="isSupplierMode || processingStatus == processingStatus_batch || processingStatus == processingStatus_failedPayment"
              field="VAT" header="VAT" [sortable]="true" styleClass="align-center">
        <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item.vat | currency:'GBP':'symbol':'1.2-2' }}
        </ng-template>
    </p-column>
    <p-column field="total" header="Total" [sortable]="true" styleClass="align-center">
        <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | currency:'GBP':'symbol':'1.2-2' }}
        </ng-template>
    </p-column>
    <p-column field="supplierInvoiceNumber" [sortable]="true" *ngIf="isSupplierMode && !supplierAgreedSelfBilling" header="Supplier Inv">
        <ng-template let-col let-item="rowData" pTemplate="body">
            <a href='~' (click)="openPdf(item.supplierInvoicePdf);$event.preventDefault();">{{item.supplierInvoiceNumber}}</a>
            <span *ngIf="!item.supplierInvoiceNumber">Outstanding</span>
        </ng-template>
    </p-column>
    <p-column field="supplierInvoiceDate" [sortable]="true" *ngIf="isSupplierMode && !supplierAgreedSelfBilling" header="Supp Inv Date">
        <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | datex:'DD MMM YYYY' }}
        </ng-template>
    </p-column>
    <p-column *ngIf="isSupplierMode || processingStatus == processingStatus_batch || processingStatus == processingStatus_supplier"
              field="paidOn" header="Paid" [sortable]="true" styleClass="align-center">
        <ng-template let-col let-item="rowData" pTemplate="body">
            <span *ngIf="item.paidOn">{{item.paidOn | datex:'DD MMM YYYY'}}</span>
            <span *ngIf="!item.paidOn" style="text-transform: capitalize;">{{item.paymentStatus}}</span>
        </ng-template>
    </p-column>
    <p-column *ngIf="isSupplierMode || processingStatus == processingStatus_batch || processingStatus == processingStatus_supplier"
              field="XeroInvoiceNumber" header="Xero Batch Invoice Number" [sortable]="true" styleClass="align-center">
        <ng-template let-col let-item="rowData" pTemplate="body">
            <span *ngIf="item.xeroInvoiceNumber">{{item.xeroInvoiceNumber}}</span>
        </ng-template>
    </p-column>
    <p-column *ngIf="processingStatus == processingStatus_cancelled"
              field="invoiceCancelledOn" header="Cancelled" [sortable]="true" styleClass="align-center">
        <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | datex:'DD MMM YYYY' }}
        </ng-template>
    </p-column>
    <p-column *ngIf="processingStatus == processingStatus_cancelled"
              field="invoiceCancelledReason" header="Reason" [sortable]="true">
        <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] }}
        </ng-template>
    </p-column>
    <p-column *ngIf="processingStatus == processingStatus_failedPayment"
              field="failedStatus" header="Status & Reason" [sortable]="true">
        <ng-template let-col let-item="rowData" pTemplate="body">
        </ng-template>
    </p-column>
    <p-column *ngIf="isSupplierMode" header="View" styleClass="align-center">
        <ng-template let-col let-item="rowData" pTemplate="body">
            <a href='~' *ngIf="!supplierAgreedSelfBilling && item.supplierInvoiceNumber"
               (click)="openPdf(item.supplierInvoicePdf);$event.preventDefault();">
                <span class="ui-clickable fa fa-fw ui-icon-document"></span>
            </a>
            <a *ngIf="supplierAgreedSelfBilling" (click)="openInvoiceViewPanel(item.id);$event.preventDefault();">
                <span class="ui-clickable fa fa-fw ui-icon-document"></span>
            </a>
        </ng-template>
    </p-column>
    <p-column *ngIf="processingStatus == processingStatus_batch || processingStatus == processingStatus_failedPayment || processingStatus == processingStatus_unbatchedInvoice || processingStatus == processingStatus_supplier"
              header="Proforma/Invoice" styleClass="align-center">
        <ng-template let-col let-item="rowData" pTemplate="body">
            <a *ngIf="item.supplierInvoiceNumber" href='~' (click)="openPdf(item.supplierInvoicePdf);$event.preventDefault();">
                <span class="ui-clickable fa fa-fw ui-icon-document"></span>
            </a>
            <a *ngIf="!item.supplierInvoiceNumber" (click)="openInvoiceViewPanel(item.id);$event.preventDefault();">
                <span class="ui-clickable fa fa-fw ui-icon-document"></span>
            </a>
        </ng-template>
    </p-column>
    <p-column *ngIf="processingStatus == processingStatus_batch || processingStatus == processingStatus_failedPayment || processingStatus == processingStatus_unbatchedInvoice"
              field="supplierInvoiceNumber" header="Supplier Inv" [sortable]="true" styleClass="align-center">
        <ng-template let-col let-item="rowData" pTemplate="body">
            <a href='~' (click)="openPdf(item.supplierInvoicePdf);$event.preventDefault();">{{item.supplierInvoiceNumber}}</a>
        </ng-template>
    </p-column>

    <p-column *ngIf="processingStatus == processingStatus_batch || processingStatus == processingStatus_failedPayment || processingStatus == processingStatus_unbatchedInvoice"
              field="supplierInvoiceDate" header="Supp Inv Date" [sortable]="true" styleClass="align-center">
        <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | datex:'DD MMM YYYY' }}
        </ng-template>
    </p-column>

    <p-column *ngIf="isTestMode && (processingStatus == processingStatus_batch  || processingStatus == processingStatus_unbatchedInvoice)" header="TESTING"
              [sortable]="false" [style]="{'text-align' : 'center', 'width' : '20%'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
            <a href="#" (click)="removeInvoice(item.id);$event.preventDefault();">Remove</a> <br /><br />
            <div *ngIf="item.transactionId">
                Webhook:
                <a href="#" (click)="emulateWebhookCompleted(item);$event.preventDefault();">completed</a> |
                <a href="#" (click)="emulateWebhookFailed(item);$event.preventDefault();">failed</a>
            </div>
        </ng-template>
    </p-column>
</p-dataTable>

-->

<div class="footerPanel ui-grid-row">
  <button
    *ngIf="processingStatus == processingStatus_batch"
    class="btn-to-right"
    [disabled]="
      !selectedInvoice ||
      selectedInvoice.paymentStatus == paymentStatus_pending ||
      selectedInvoice.paymentStatus == paymentStatus_completed
    "
    type="button"
    (click)="cancelInvoiceDialog()"
    label="Cancel Invoice"
    pButton
  ></button>
  <button
    *ngIf="processingStatus == processingStatus_failedPayment"
    class="btn-to-right"
    [disabled]="!selectedInvoice"
    type="button"
    (click)="resendPaymentsDialogVisible = true"
    label="Resend for Payment"
    pButton
  ></button>
  <!--<button *ngIf="processingStatus == processingStatus_cancelled" class="btn-to-right"
          type="button" (click)="uncancelInvoice(selectedInvoice)"
          label="Uncancel Invoice" pButton [disabled]="!selectedInvoice"></button>-->
  <button
    type="button"
    pButton
    icon="fa ui-icon-file-download"
    label="Download"
    class="ui-button btn-to-right"
    (click)="downloadSupplierReport()"
    [disabled]="page.total == 0"
  ></button>
</div>

<div *ngIf="viewInvoiceId">
  <div class="card card-w-title" style="margin-top: 2em; margin-bottom: 2em">
    <supplier-invoice-view
      [invoiceId]="viewInvoiceId"
      (onHide)="onInvoiceViewHide()"
    ></supplier-invoice-view>
  </div>
</div>

<div *ngIf="selectedInvoice">
  <div class="ui-grid-row">
    <div class="ui-g-7 ui-sm-12">
      <h2>Transactions</h2>

      <transaction-lines-grid
        [supplierInvoiceId]="selectedInvoice.id"
        [manageMode]="2"
      ></transaction-lines-grid>
    </div>

    <div class="ui-g-4 ui-sm-12 pull-right mt-4">
      <form [formGroup]="invoiceForm">
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Invoice Number</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              formControlName="invoiceNumber"
              name="invoiceNumber"
              [readonly]="isSupplierMode"
              pInputText
              class="form-component"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Xero Invoice Number</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              formControlName="xeroInvoiceNumber"
              name="xeroInvoiceNumber"
              [readonly]="isSupplierMode"
              pInputText
              class="form-component"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Invoice Date</label>
          </div>
          <div class="ui-grid-col-8">
            <p-calendar
              formControlName="invoiceDate"
              name="invoiceDate"
              [showTime]="false"
              [showIcon]="true"
              dateFormat="dd M yy"
              [disabled]="isSupplierMode"
              [styleClass]="isSupplierMode ? 'no-disable-inputtext' : ''"
            ></p-calendar>
            <div
              *ngIf="inputErrorToShow(invoiceForm.controls['invoiceDate'])"
              class="ui-message ui-messages-error ui-corner-all"
            >
              {{ inputErrorToShow(invoiceForm.controls['invoiceDate']) }}
            </div>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Supplier</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              formControlName="supplierName"
              name="supplierName"
              [readonly]="isSupplierMode"
              pInputText
              class="form-component"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Invoice Address 1</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              formControlName="supplierAddress1"
              name="supplierAddress1"
              [readonly]="isSupplierMode"
              pInputText
              class="form-component"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4"><label>Invoice Address 2</label></div>
          <div class="ui-grid-col-8">
            <input
              formControlName="supplierAddress2"
              name="supplierAddress2"
              [readonly]="isSupplierMode"
              pInputText
              class="form-component"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4"><label>Invoice Address 3</label></div>
          <div class="ui-grid-col-8">
            <input
              formControlName="supplierAddress3"
              name="supplierAddress3"
              [readonly]="isSupplierMode"
              pInputText
              class="form-component"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4"><label>Town</label></div>
          <div class="ui-grid-col-8">
            <input
              formControlName="supplierAddressCity"
              name="supplierAddressCity"
              [readonly]="isSupplierMode"
              pInputText
              class="form-component"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4"><label>Post Code</label></div>
          <div class="ui-grid-col-8">
            <input
              formControlName="supplierAddressPostcode"
              name="supplierAddressPostcode"
              [readonly]="isSupplierMode"
              pInputText
              class="form-component"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Phone</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              formControlName="supplierPhone"
              name="supplierPhone"
              [readonly]="isSupplierMode"
              pInputText
              class="form-component"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>VAT Number</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              formControlName="vatNumber"
              name="vatNumber"
              [readonly]="isSupplierMode"
              pInputText
              class="form-component"
            />
          </div>
        </div>
        <div *ngIf="isVmeMode" class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>VAT Rate</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              formControlName="vatRate"
              name="vatRate"
              maxlength="5"
              (keydown)="inputHelper.allowNumberInputKey($event)"
              pInputText
              class="form-component"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Company Registration</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              formControlName="companyRegistrationNumber"
              name="companyRegistrationNumber"
              [readonly]="isSupplierMode"
              pInputText
              class="form-component"
            />
          </div>
        </div>
        <div *ngIf="isVmeMode" class="ui-g-11">
          <button
            type="button"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            class="ui-button btn-to-right"
            [disabled]="!invoiceForm.valid"
            (click)="updateInvoice(selectedInvoice.id, invoiceForm.value)"
          ></button>
        </div>
      </form>

      <div *ngIf="isVmeMode">
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Bank Account Name</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              [readonly]="true"
              pInputText
              class="form-component"
              [value]="bankAccount ? bankAccount.name : ''"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Sort Code</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              [readonly]="true"
              pInputText
              id="invSortCode"
              class="form-component"
              [value]="bankAccount ? bankAccount.sortCode : ''"
            />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-grid-col-4">
            <label>Account Code</label>
          </div>
          <div class="ui-grid-col-8">
            <input
              [readonly]="true"
              pInputText
              class="form-component"
              [value]="bankAccount ? bankAccount.accountNumber : ''"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="isSupplierMode && !supplierAgreedSelfBilling"
    class="ui-grid-row"
    style="margin-top: 10px"
  >
    <form [formGroup]="invoicePdfForm">
      <div class="ui-g-5" style="float: right">
        <div class="ui-grid-row">
          <div class="ui-g-8">
            <div class="ui-grid-col-4">
              <label>Your Invoice Number</label>
            </div>
            <div class="ui-grid-col-8">
              <input
                formControlName="supplierInvoiceNumber"
                name="supplierInvoiceNumber"
                pInputText
                class="form-component"
              />
            </div>
          </div>
          <div class="ui-g-4">
            <p-fileUpload
              #fileuploadInvoice
              name="file"
              url="/api/supplierinvoices/uploadinvoice"
              accept=".pdf"
              mode="advanced"
              chooseLabel="Select PDF"
              [showCancelButton]="false"
              [showUploadButton]="false"
              (onSelect)="onSelectInvoicePdf($event)"
              (onBeforeUpload)="onBeforeUploadInvoicePdf(selectedInvoice.id, $event)"
              (onUpload)="onUploadInvoicePdf($event)"
              (onError)="onUploadInvoicePdfError($event)"
              [styleClass]="
                pdfSelectorEnabled()
                  ? 'file-upload-advanced-simplified'
                  : 'file-upload-advanced-simplified file-upload-advanced-simplified-disabled'
              "
              [disabled]="!pdfSelectorEnabled()"
            >
            </p-fileUpload>
          </div>
        </div>

        <div class="ui-grid-row">
          <div class="ui-g-8">
            <div class="ui-grid-col-4">
              <label>Your Invoice Date</label>
            </div>
            <div class="ui-grid-col-8">
              <p-calendar
                formControlName="supplierInvoiceDate"
                name="supplierInvoiceDate"
                [showTime]="false"
                [showIcon]="true"
                dateFormat="D d MM"
                [disabled]="false"
              ></p-calendar>
              <div
                *ngIf="inputErrorToShow(invoicePdfForm.controls['supplierInvoiceDate'])"
                class="ui-message ui-messages-error ui-corner-all"
              >
                {{ inputErrorToShow(invoicePdfForm.controls['supplierInvoiceDate']) }}
              </div>
            </div>
          </div>
          <div *ngIf="selectedInvoicePdf" class="ui-g-4">
            "<b>{{ selectedInvoicePdf }}</b
            >" uploading...
          </div>
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="isVmeMode" class="ui-grid-row">
    <div class="ui-g-12">
      <h2>Payment History</h2>

      <p-table
        [value]="pagePayments.items"
        [lazy]="true"
        [rows]="10"
        [responsive]="true"
        rowHover="true"
        resizableColumns="true"
        [paginator]="true"
        [totalRecords]="pagePayments.total"
        (onLazyLoad)="onGridLazyLoadPayments($event)"
        [hidden]="!isLoadedPayments"
        selectionMode="single"
        [rowsPerPageOptions]="[5, 10, 20]"
        [pageLinks]="3"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Payment ID</th>
            <th>Created</th>
            <th>Status</th>
            <th>Reason</th>
            <th>Revolut Completed</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td>{{ item.paymentId }}</td>
            <td>{{ item.createdOn | datex : 'DD MMM YYYY' }}</td>
            <td>
              <span style="text-transform: capitalize">{{ item.revolutStatus }}</span>
            </td>
            <td>{{ item.revolutCreatedAt | datex : 'ddd DD MMM HH:mm' }}</td>
            <td>{{ item.revolutCompleteAt | datex : 'ddd DD MMM HH:mm' }}</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DATATABLE DEPRECATED ---
      <p-dataTabl [value]="pagePayments.items" [lazy]="true" [rows]="10" [responsive]="true" rowHover="true"
                   resizableColumns="true"
                   [paginator]="true" [totalRecords]="pagePayments.total" (onLazyLoad)="onGridLazyLoadPayments($event)"
                   [hidden]="!isLoadedPayments" selectionMode="single" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3">
        <p-column field="paymentId" header="Payment ID" [sortable]="true">
        </p-column>
        <p-column field="createdOn" header="Created" [sortable]="true" styleClass="align-center">
          <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | datex:'DD MMM YYYY' }}
          </ng-template>
        </p-column>
        <p-column field="revolutStatus" header="Status" [sortable]="true" styleClass="align-center">
          <ng-template let-col let-item="rowData" pTemplate="body">
            <span style="text-transform: capitalize;">{{item[col.field]}}</span>
          </ng-template>
        </p-column>
        <p-column field="revolutReason" header="Reason" [sortable]="true"></p-column>
        <p-column field="revolutCreatedAt" header="Revolut Created At" [sortable]="true" styleClass="align-center">
          <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | datex:'ddd DD MMM HH:mm' }}
          </ng-template>
        </p-column>
        <p-column field="revolutCompletedAt" header="Revolut Completed At" [sortable]="true" styleClass="align-center">
          <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | datex:'ddd DD MMM HH:mm' }}
          </ng-template>
        </p-column>
      </p-dataTable>
      ---->
    </div>
  </div>
</div>

<p-dialog
  header="Cancel Invoice"
  [(visible)]="cancelInvoiceDialogVisible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row">
      <div class="ui-g-4"><label for="dialogDepots">Reason</label></div>
      <div class="ui-g-8">
        <textarea
          [(ngModel)]="cancelInvoiceReason"
          rows="5"
          maxlength="200"
          class="ui-inputtextarea"
          pInputTextarea
          ngModel
          name="text"
        ></textarea>
      </div>
    </div>
  </div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>
  <div class="ui-grid-row" style="float: right">
    <button
      type="button"
      class="ui-button-danger"
      pButton
      (click)="
        cancelInvoice(selectedInvoice, cancelInvoiceReason); cancelInvoiceDialogVisible = false
      "
      label="Cancel Invoice"
      [disabled]="!cancelInvoiceReason || !cancelInvoiceReason.trim()"
    ></button>
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      (click)="cancelInvoiceDialogVisible = false"
    ></button>
  </div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>
</p-dialog>

<p-dialog
  header="Resend for Payment"
  [(visible)]="resendPaymentsDialogVisible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row">You are going to resend for payment</div>
  </div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>
  <div class="ui-grid-row" style="float: right">
    <button
      type="button"
      class="green-btn"
      icon="fa ui-icon-check"
      pButton
      (click)="confirmResendFailedInvoice(selectedInvoice); resendPaymentsDialogVisible = false"
      label="Confirm"
    ></button>
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="Cancel"
      (click)="resendPaymentsDialogVisible = false"
    ></button>
  </div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>
</p-dialog>

<p-dialog
  header="Invoice Report"
  key="invoiceReportDialog"
  [(visible)]="invoiceReportDialogVisible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row">
      <div class="ui-g-12 invoice-report-title">Report for yet to be batched invoices</div>
    </div>
  </div>
  <div *ngIf="invoiceReportDialogVisible" class="ui-grid-row invoice-report-form">
    <form [formGroup]="invoiceReport">
      <div class="ui-g-12">
        <div class="ui-grid-col-8">
          <label>Total Number of Invoices</label>
        </div>
        <div class="ui-grid-col-4">
          <div class="form-component">{{ invoiceReport.get('numberOfInvoices').value }}</div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-8">
          <label>Total Number of Transactions</label>
        </div>
        <div class="ui-grid-col-4">
          <div class="form-component">{{ invoiceReport.get('numberOfTransactions').value }}</div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-8">
          <label>Sub Total (VAT)</label>
        </div>
        <div class="ui-grid-col-4">
          <div class="form-component">
            {{ invoiceReport.get('subTotalVAT').value | currency : 'GBP' : 'symbol' : '1.2-2' }}
          </div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-8">
          <label>Sub Total (No-VAT)</label>
        </div>
        <div class="ui-grid-col-4">
          <div class="form-component">
            {{ invoiceReport.get('subTotalNoVAT').value | currency : 'GBP' : 'symbol' : '1.2-2' }}
          </div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-8">
          <label>VAT Total</label>
        </div>
        <div class="ui-grid-col-4">
          <div class="form-component">
            {{ invoiceReport.get('vat').value | currency : 'GBP' : 'symbol' : '1.2-2' }}
          </div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-8">
          <label>Total</label>
        </div>
        <div class="ui-grid-col-4">
          <div class="form-component">
            {{ invoiceReport.get('total').value | currency : 'GBP' : 'symbol' : '1.2-2' }}
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="ui-grid-row" style="float: right">
    <div class="ui-g-12">
      <button
        type="button"
        class="green-btn"
        icon="fa ui-icon-check"
        pButton
        (click)="invoiceReportDialogVisible = false"
        label="Ok"
      ></button>
    </div>
  </div>

  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>
</p-dialog>
